import type { SxProps, Theme } from '@mui/material';

import {
  GRAY_LIGHT_SECONDARY,
  MINT,
  PRIMARY,
  PRIMARY_LIGHT
} from 'constants/colors';

export const dataGridSx: SxProps<Theme> = {
  width: '100%',
  height: 'auto',
  border: 'none',
  backgroundColor: '#fff',
  '& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader, & .MuiDataGrid-pinnedColumns, & .MuiDataGrid-pinnedColumnHeaders, & .MuiDataGrid-cell, & .MuiDataGrid-row, & .MuiDataGrid-main, & .MuiDataGrid-topContainer, & .MuiDataGrid-bottomContainer, & .MuiDataGrid-scrollbarFiller, & .MuiDataGrid-filler':
    {
      backgroundColor: '#fff !important'
    },
  '& .MuiDataGrid-cell': {
    borderRight: 'none',
    borderLeft: 'none',
    borderColor: GRAY_LIGHT_SECONDARY,
    '&:focus, &:focus-within': {
      outline: 'none'
    }
  },
  '& .MuiDataGrid-cell .MuiDataGrid-cellContent': {
    overflow: 'visible',
    whiteSpace: 'normal',
    height: '100%'
  },
  '& .MuiDataGrid-columnHeader': {
    borderRight: 'none',
    borderLeft: 'none',
    '&:focus, &:focus-within': {
      outline: 'none'
    }
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    justifyContent: 'center'
  },
  '& .MuiDataGrid-columnHeaders': {
    borderTop: 'none'
  },
  '& .MuiDataGrid-scrollbar--vertical': {
    display: 'none'
  }
};

export const activityChipSx: SxProps<Theme> = {
  height: 22,
  fontSize: '0.6rem',
  fontWeight: 500,
  borderColor: MINT,
  color: PRIMARY,
  backgroundColor: PRIMARY_LIGHT,
  alignSelf: 'flex-start',
  '& .MuiChip-label': { px: 1 }
};
